export default "__VITE_ASSET__OC6COw01__"